import { takeEvery, put, call, select } from 'redux-saga/effects'

import api from 'api'

import {
  loadindFailed,
  loadingDevicesSuccess,
  loadingDevices,
  deleteDevices,
  updateDevices,
  createDevices,
  successUpdates,
  failedUpdates,
  loadindPanelFailed,
  loadingPanel,
  loadingPanelSuccess,
  updatePanel,
  successUpdatesPanel,
  failedUpdatesPanel,
  addMeter,
  addMeterFailed,
  addMeterSuccess,
  getPanelListSelector,
  getAdminProfile,
  setAdminProfile,
  setIsFetchingAdminProfile,
} from 'redux/reducers/devices'
import { showAlert } from 'redux/reducers/notification'

function* getDevicesSagaWorker() {
  try {
    const { data } = yield call([api.devices, 'getDevices'])
    yield put(loadingDevicesSuccess(data?.body?.devices))
  } catch (error) {
    yield put(loadindFailed(error?.message))
  }
}

function* deleteDeviceWorker({ payload }) {
  try {
    yield call([api.devices, 'deleteDevice'], payload)
    yield put(successUpdates())
    yield put(
      showAlert({
        message: 'The device was successfully deleted',
        timeoutHide: 10000,
      })
    )
    yield put(loadingDevices())
  } catch (error) {
    yield put(failedUpdates())
    yield put(
      showAlert({
        message: 'The deleting device is failed',
        severity: 'error',
        timeoutHide: 0,
      })
    )
  }
}

function* updateDeviceWorker({ payload }) {
  try {
    const { id, ...data } = payload
    yield call([api.devices, 'updateDevice'], id, data)
    yield put(successUpdates())
    yield put(
      showAlert({
        message: 'The device was successfully updated',
        timeoutHide: 10000,
      })
    )
    yield put(loadingDevices())
  } catch (error) {
    yield put(failedUpdates())
    const _message =
      (error?.response?.data?.details && error?.response?.data?.details[0]) ||
      'The creating device is failed'
    yield put(
      showAlert({
        message: _message,
        severity: 'error',
        timeoutHide: 0,
      })
    )
  }
}

function* createDeviceWorker({ payload }) {
  try {
    yield call([api.devices, 'createDevice'], payload)
    yield put(successUpdates())
    yield put(
      showAlert({
        message: 'The device was successfully created',
        timeoutHide: 10000,
      })
    )
    yield put(loadingDevices())
  } catch (error) {
    yield put(failedUpdates())
    const _message =
      (error?.response?.data?.details && error?.response?.data?.details[0]) ||
      'The creating device is failed'
    yield put(
      showAlert({
        message: _message,
        severity: 'error',
        timeoutHide: 0,
      })
    )
  }
}

function* getPanelsSagaWorker() {
  try {
    const { data } = yield call([api.devices, 'getPanel'])
    yield put(loadingPanelSuccess(data?.body))
  } catch (error) {
    yield put(loadindPanelFailed(error?.message))
  }
}

function* updatePanelsSagaWorker({ payload }) {
  try {
    const { id, ...rest } = payload
    const { data } = yield call([api.devices, 'updatePanel'], id, rest)

    const panelsList = yield select(getPanelListSelector)

    const updatedPanelList = panelsList.reduce((res, item) => {
      if (item.id === data.body.id) {
        res.push(data.body)
      } else res.push(item)

      return res
    }, [])

    yield put(successUpdatesPanel(updatedPanelList))
    yield put(
      showAlert({
        message: 'The panel was successfully updated',
        timeoutHide: 10000,
      })
    )
  } catch (error) {
    yield put(failedUpdatesPanel())
    yield put(
      showAlert({
        message: 'The updating panel is failed',
        severity: 'error',
        timeoutHide: 0,
      })
    )
  }
}

function* updatePanelMeterSagaWorker({ payload }) {
  try {
    const { id, ...rest } = payload
    const { data } = yield call([api.devices, 'updatePanel'], id, rest)

    const panelsList = yield select(getPanelListSelector)

    const updatedPanelList = panelsList.reduce((res, item) => {
      if (item.id === data.body.id) {
        res.push(data.body)
      } else res.push(item)

      return res
    }, [])

    yield put(addMeterSuccess(updatedPanelList))
    yield put(
      showAlert({
        message: 'The meter has been added is success',
        timeoutHide: 10000,
      })
    )
  } catch (error) {
    yield put(addMeterFailed())
    yield put(
      showAlert({
        message: 'The adding meter is failed',
        severity: 'error',
        timeoutHide: 0,
      })
    )
  }
}

function* getAdminProfileSagaWorker() {
  try {
    yield put(setIsFetchingAdminProfile(true))
    const { data } = yield call([api.devices, 'getAdminProfile'])
    yield put(setAdminProfile(data?.body))
  } catch (error) {
    yield put(
      showAlert({
        message: 'Something went wrong!',
        severity: 'error',
        timeoutHide: 0,
      })
    )
  } finally {
    yield put(setIsFetchingAdminProfile(false))
  }
}

export default function* devicesSagaWatcher() {
  yield takeEvery(loadingDevices.type, getDevicesSagaWorker)
  yield takeEvery(deleteDevices.type, deleteDeviceWorker)
  yield takeEvery(updateDevices.type, updateDeviceWorker)
  yield takeEvery(createDevices.type, createDeviceWorker)
  yield takeEvery(loadingPanel.type, getPanelsSagaWorker)
  yield takeEvery(updatePanel.type, updatePanelsSagaWorker)
  yield takeEvery(addMeter.type, updatePanelMeterSagaWorker)
  yield takeEvery(getAdminProfile.type, getAdminProfileSagaWorker)
}
